interface ShieldIconProps {
  color?: string;
}

function ShieldIcon({ color = '#017993' }: ShieldIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-label="Medical coverage"
    >
      <rect width="24" height="24" rx="12" fill="" />
      <path
        d="M9.375 12.04C9.375 11.8702 9.44085 11.7075 9.55806 11.5874C9.67527 11.4674 9.83424 11.4 10 11.4H11.875V9.47999C11.875 9.31025 11.9408 9.14746 12.0581 9.02744C12.1753 8.90742 12.3342 8.83999 12.5 8.83999C12.6658 8.83999 12.8247 8.90742 12.9419 9.02744C13.0592 9.14746 13.125 9.31025 13.125 9.47999V11.4H15C15.1658 11.4 15.3247 11.4674 15.4419 11.5874C15.5592 11.7075 15.625 11.8702 15.625 12.04C15.625 12.2097 15.5592 12.3725 15.4419 12.4925C15.3247 12.6126 15.1658 12.68 15 12.68H13.125V14.6C13.125 14.7697 13.0592 14.9325 12.9419 15.0525C12.8247 15.1725 12.6658 15.24 12.5 15.24C12.3342 15.24 12.1753 15.1725 12.0581 15.0525C11.9408 14.9325 11.875 14.7697 11.875 14.6V12.68H10C9.83424 12.68 9.67527 12.6126 9.55806 12.4925C9.44085 12.3725 9.375 12.2097 9.375 12.04ZM20 6.28V10.76C20 14.9776 18.0063 17.5336 16.3336 18.9352C14.532 20.444 12.7398 20.9568 12.6617 20.9776C12.5543 21.0075 12.441 21.0075 12.3336 20.9776C12.2555 20.9568 10.4656 20.444 8.66172 18.9352C6.99375 17.5336 5 14.9776 5 10.76V6.28C5 5.94052 5.1317 5.61495 5.36612 5.3749C5.60054 5.13486 5.91848 5 6.25 5H18.75C19.0815 5 19.3995 5.13486 19.6339 5.3749C19.8683 5.61495 20 5.94052 20 6.28ZM18.75 6.28H6.25V10.76C6.25 13.744 7.32969 16.1608 9.45859 17.9448C10.365 18.7039 11.3944 19.2944 12.5 19.6896C13.6202 19.2874 14.6625 18.6862 15.5789 17.9136C17.6828 16.1328 18.75 13.7256 18.75 10.76V6.28Z"
        fill={color}
      />
    </svg>
  );
}

export default ShieldIcon;
